import { render, staticRenderFns } from "./FileIcon.vue?vue&type=template&id=615bd750&scoped=true&"
import script from "./FileIcon.vue?vue&type=script&lang=js&"
export * from "./FileIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615bd750",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('615bd750')) {
      api.createRecord('615bd750', component.options)
    } else {
      api.reload('615bd750', component.options)
    }
    module.hot.accept("./FileIcon.vue?vue&type=template&id=615bd750&scoped=true&", function () {
      api.rerender('615bd750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Util/FileIcon.vue"
export default component.exports